import { Action } from '../actions';
import { transformUser } from '../user/user.transformers';

import {
  firstReferenceFromReferenceList,
  mergeEntities,
  RawStoreListStateSlice,
  transformObjects,
} from '../helpers';

export function contactReducer(
  state: RawStoreListStateSlice<'contacts'> = {},
  action: Action,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'contacts') {
        const { result, refList } = action.payload;
        const users = result.contacts ? result.contacts.map(c => c.user) : [];
        return mergeEntities<'contacts'>(
          state,
          transformObjects(users, transformUser, refList.pathList[1][0]),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/datastore/contact/contact.reducer.ts